import { bottomRightOfBeltEmbroideryDrawer, sideOfLabelEmbroideryDrawer } from 'src/features/brands/treasure/canvas/common/back/useCanvasEmbroideries'
import { State } from 'src/types'
import { edgeOfCommon } from '../edge'
import { hamidashiOfMiddleFingerBeltBackStyle } from '../hamidashi'
import { littleRingMergedFingerOfBeltBackStyle } from '../littleRingFinger'
import { thumbFingerOfBeltBackStyle } from '../thumbFinger'
import { beltTypeDrawer } from './beltTypeDrawer'

export const beltStyleDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isBeltBackStyle =
    state?.baseModel?.backStyle === 'beltBackStyle' || state?.backStyle?.value === 'beltBackStyle' || state?.backStyle?.value === 'unselected'
  if (!isBeltBackStyle) return

  // 小指側の指袋
  littleRingMergedFingerOfBeltBackStyle(ctx, state?.middleLeftRingLittle?.color, state.stitch.color)

  // 親指側の指袋
  thumbFingerOfBeltBackStyle(ctx, state?.thumbIndexMiddleRight?.color, state.stitch.color)

  // ベルトスタイルのハミダシ
  hamidashiOfMiddleFingerBeltBackStyle(ctx, state.hamidashi)

  // ヘリ革
  edgeOfCommon(ctx, state.edge.color)

  // ベルトタイプ別の描画
  beltTypeDrawer(ctx, state)

  bottomRightOfBeltEmbroideryDrawer(ctx, state.embroideries, -35, 45)
  // Treasure＿ラベル左への刺繍
  sideOfLabelEmbroideryDrawer(ctx, state.embroideries, -10, 50)
}
